function cacheData(state= {}, action) {
  return state;
}

export default cacheData;
